module.exports = __webpack_public_path__ + "img/teamwork.673f2cd0.png";